/**
 * @file deep-freeze.ts
 * @description Рекурсивная заморозка констант-умолчаний (phase19.16, SB120
 * этап 4 — вынесено по ревью из трёх одинаковых копий: schema.ts
 * `DEFAULT_SITE_THEME`, cart.ts `DEFAULT_SITE_CART`, site-section/defaults.ts
 * `DEFAULT_SECTION_PAYLOAD`). Умолчание платформы отдаётся в слияние и в
 * кабинет — мутировать его нельзя. Модуль без импортов: циклов не создаёт.
 * Внутренний помощник пакета, из барреля не экспортируется.
 */

/**
 * Замораживает значение и всё вложенное; возвращает то же значение.
 * Регулярные выражения не замораживаются: у них изменяемое состояние
 * `lastIndex`, и zod при проверке строки его сбрасывает (Р3г — шаблоны
 * номеров в реестре сервисов счётчиков).
 */
export function deepFreeze<T>(value: T): T {
  if (value instanceof RegExp) return value;
  if (typeof value === "object" && value !== null) {
    for (const nested of Object.values(value)) deepFreeze(nested);
    Object.freeze(value);
  }
  return value;
}
